<template>
  <form v-on:submit.prevent="submitForm()">
    <p>Введите адрес электронной почты из вашего профиля, а мы пришлём ссылку для восстановления пароля.</p>
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-at" /></div>
        <input
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.form.email.length }"
          placeholder="эл. почта"
          name="email"
          value=""
          v-model="form.email" />
        <div v-if="errors.form.email.length" class="invalid-feedback">{{ errors.form.email }}</div>
      </div>
    </div>

    <div data-error class="alert alert-info mb-1 mt-3 px-2 py-1" role="alert">{{ errors.form.common }}</div>

    <div class="mt-2 mb-1 text-end">
      <button
        type="submit"
        class="btn btn-primary"
        :disabled="form.email.length == 0 || errors.form.email.length || isLoading">
        <font-awesome-icon icon="fa-solid fa-check"></font-awesome-icon> Отправить
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck, faAt } from '@fortawesome/free-solid-svg-icons';
library.add(faCheck, faAt);

import { checkEmail } from '@/composable/functions';

export default {
  data: function () {
    return {
      isLoading: false,
      //
      form: {
        _token: this.csrf,
        email: '',
      },
      errors: {
        form: {
          email: '',
          common: '',
        },
      },
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
  },
  components: {
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      if (this.form.email === '') {
        this.errors.form.email = 'Нужно указать адрес эл. почты.';
        return false;
      }

      this.isLoading = true;

      axios
        .post(`/evocms-user/reset-password`, this.form)
        .then((res) => {
          const { data } = res;

          if (data.status == 'ok') {
            this.errors.form.common = 'На указанную почту отправлено письмо с инструкцией по восстановлению пароля.';

            this.form.email = '';
          }
          if (data.status == 'error') {
            const errors = data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];
            // если почтовый сервер недоступен
            const failErrors = errors.fail || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ') + ' ' + failErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    'form.email'(newVal) {
      this.errors.form.email = checkEmail(newVal);
    },
  },
};
</script>
